import React, { Component } from 'react'
import styled from 'styled-components'

const Links = styled.div`
  font-size: 0.75rem;
  margin-top: 2rem;
  color: #ccc;
  a {
    color: inherit;
    margin: 0.25rem;
  }
`

class Sharing extends Component {
  render () {
    return (
      <Links>
        Share on
        <a href='https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdragitdownonyou.com' target='_blank'>Facebook</a>
        <span> / </span>
        <a href='https://twitter.com/intent/tweet/?text=14%20Songs%2C%2014%20Days%2C%20timed%20and%20ephemeral.%20%20Handwritten%20lyrics%20by%20Tom%20Lanyon%2C%20taken%20from%20Drag%20It%20Down%20On%20You%2C%20the%20new%20album%20by%20Ceres.%20One%20song%20each%20day%2C%20starting%20at%2012am%2C%20anywhere%20you%20are%20in%20the%20world.%20Displaying%20for%2024%20hours%20only.&amp;url=https%3A%2F%2Fdragitdownonyou.com' target='_blank'>Twitter</a>
      </Links>
    )
  }
}

export default Sharing



/** WEBPACK FOOTER **
 ** ./src/components/Sharing.js
 **/